import axios from "axios";
import baseUrl from "../constants/baseUrl";

/// Personal Info Screen Apis Only /////

export const visionSignup = async (personalInfoData) => {
  const { data } = await axios.post(
    `${baseUrl}Auth/VisionSignup`,
    personalInfoData
  );
  return data;
};


export const sendphoneverification = async (phone) => {
  const { data } = await axios.post(`${baseUrl}Auth/Sendphoneverification`, {
    phoneNumber: phone,
  });
  return data;
};

export const verifyphone = async (phone, code) => {
  const { data } = await axios.post(`${baseUrl}Auth/Verifyphone`, {
    phoneNumber: phone,
    code: code,
  });
  return data;
};
